module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/classic-woman-tee/3-369cf29cbbe7a437a66b6be50ce85de2.jpg";